import {
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import React from "react";

class QualityDocumentSectionTwo extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange(event: any) {
    this.props.inputChangeCallback(event);
  }

  getSupplierList() {
    const { supplier } = this.props;
    if (!supplier) return [];
    return Array.isArray(supplier)
      ? supplier
      : Object.keys(supplier || {}).map((k) => supplier[k]);
  }

  getSystemList(systems: any) {
    if (!systems || typeof systems !== "object") return [];
    return Array.isArray(systems)
      ? systems
      : Object.keys(systems).map((k) => systems[k]);
  }

  render() {
    const { formData } = this.props;
    const supplierList = this.getSupplierList();

    return (
      <IonItemGroup className="form-section">
        <IonItemDivider sticky={true} mode="ios">
          Tätskiktssystem
        </IonItemDivider>

        <h2 className="ion-margin-bottom">
          Av Byggkeramikrådet godkända tätskiktssystem enligt BBV
        </h2>

        <div className="form-group-multiple has-select">
          <IonItem className="form-group-item" color="white" lines="none">
            <IonLabel position="stacked">
              Golv tillverkare/leverantör
              <span style={{ color: "red", fontSize: "20px" }}>*</span>
            </IonLabel>
            <IonSelect
              name="companysupplierfloor"
              className="w-100"
              placeholder="Välj ett alternativ"
              onIonChange={this.onInputChange}
              value={formData.companysupplierfloor.value}
            >
              {supplierList.map((supplier: any) => {
                if (!supplier || !supplier._id) return null;
                return (
                  <IonSelectOption
                    key={`floor-${supplier._id}`}
                    value={supplier._id.toString()}
                  >
                    {supplier.suppliername}
                  </IonSelectOption>
                );
              })}
            </IonSelect>
          </IonItem>

          <IonItem className="form-group-item" color="white" lines="none">
            <IonLabel position="stacked">
              Golv systembenämning
              <span style={{ color: "red", fontSize: "20px" }}>*</span>
            </IonLabel>
            <IonSelect
              name="suppliersystemfloor"
              className="w-100"
              placeholder="Välj ett alternativ"
              onIonChange={this.onInputChange}
              value={formData.suppliersystemfloor.value}
            >
              {this.getSystemList(this.props.suppliersystemfloor).map(
                (system: any) => {
                  if (!system || !system._id) return null;
                  return (
                    <IonSelectOption
                      key={`suppliersystemfloor-${system._id}`}
                      value={system._id.toString()}
                    >
                      {system.name}
                    </IonSelectOption>
                  );
                }
              )}
            </IonSelect>
          </IonItem>
        </div>

        <div className="form-group-multiple has-select">
          <IonItem className="form-group-item" color="white" lines="none">
            <IonLabel position="stacked">
              Vägg våtzon 1 tillverkare/leverantör
              <span style={{ color: "red", fontSize: "20px" }}>*</span>
            </IonLabel>
            <IonSelect
              name="companywallzone1supplier"
              className="w-100"
              placeholder="Välj ett alternativ"
              onIonChange={this.onInputChange}
              value={formData.companywallzone1supplier.value}
            >
              {supplierList.map((supplier: any) => {
                if (!supplier || !supplier._id) return null;
                return (
                  <IonSelectOption
                    key={`wall-1-${supplier._id}`}
                    value={supplier._id.toString()}
                  >
                    {supplier.suppliername}
                  </IonSelectOption>
                );
              })}
            </IonSelect>
          </IonItem>

          <IonItem className="form-group-item" color="white" lines="none">
            <IonLabel position="stacked">
              Vägg våtzon 1 systembenämning
              <span style={{ color: "red", fontSize: "20px" }}>*</span>
            </IonLabel>
            <IonSelect
              name="suppliersystemwallzone1"
              className="w-100"
              placeholder="Välj ett alternativ"
              onIonChange={this.onInputChange}
              value={formData.suppliersystemwallzone1.value}
            >
              {this.getSystemList(this.props.suppliersystemwallzone1).map(
                (system: any) => {
                  if (!system || !system._id) return null;
                  return (
                    <IonSelectOption
                      key={`suppliersystemwallzone1-${system._id}`}
                      value={system._id.toString()}
                    >
                      {system.name}
                    </IonSelectOption>
                  );
                }
              )}
            </IonSelect>
          </IonItem>
        </div>

        <div className="form-group-multiple has-select">
          <IonItem className="form-group-item" color="white" lines="none">
            <IonLabel position="stacked">
              Vägg våtzon 2 tillverkare/leverantör
              <span style={{ color: "red", fontSize: "20px" }}>*</span>
            </IonLabel>
            <IonSelect
              name="companywallzone2supplier"
              className="w-100"
              placeholder="Välj ett alternativ"
              onIonChange={this.onInputChange}
              value={formData.companywallzone2supplier.value}
            >
              {supplierList.map((supplier: any) => {
                if (!supplier || !supplier._id) return null;
                return (
                  <IonSelectOption
                    key={`wall-2-${supplier._id}`}
                    value={supplier._id.toString()}
                  >
                    {supplier.suppliername}
                  </IonSelectOption>
                );
              })}
            </IonSelect>
          </IonItem>

          <IonItem className="form-group-item" color="white" lines="none">
            <IonLabel position="stacked">
              Vägg våtzon 2 systembenämning
              <span style={{ color: "red", fontSize: "20px" }}>*</span>
            </IonLabel>
            <IonSelect
              name="suppliersystemwallzone2"
              className="w-100"
              placeholder="Välj ett alternativ"
              onIonChange={this.onInputChange}
              value={formData.suppliersystemwallzone2.value}
            >
              {this.getSystemList(this.props.suppliersystemwallzone2).map(
                (system: any) => {
                  if (!system || !system._id) return null;
                  return (
                    <IonSelectOption
                      key={`suppliersystemwallzone2-${system._id}`}
                      value={system._id.toString()}
                    >
                      {system.name}
                    </IonSelectOption>
                  );
                }
              )}
            </IonSelect>
          </IonItem>
        </div>
      </IonItemGroup>
    );
  }
}

export default QualityDocumentSectionTwo;
